const DEFAULT_HISTORY_LIMIT = 100;
const DEFAULT_SEARCH_LIMIT = 50;

export const fetchRecentMessages = async (limit = DEFAULT_HISTORY_LIMIT, websocketUrl = process.env.REACT_APP_WS_URL) => {
  const response = await fetch(buildApiUrl(`/api/messages/recent?limit=${limit}`, websocketUrl));
  if (!response.ok) {
    throw new Error(`Error fetching recent messages: ${response.statusText}`);
  }
  return response.json();
};

export const searchDatabaseMessages = async (query, limit = DEFAULT_SEARCH_LIMIT, websocketUrl = process.env.REACT_APP_WS_URL) => {
  const response = await fetch(
    buildApiUrl(`/api/messages/search?q=${encodeURIComponent(query)}&limit=${limit}`, websocketUrl)
  );
  if (!response.ok) {
    throw new Error(`Error searching monitor history: ${response.statusText}`);
  }
  return response.json();
};

export const buildApiUrl = (path, websocketUrl = process.env.REACT_APP_WS_URL) => {
  const baseUrl = resolveHistoryApiBaseUrl(websocketUrl);
  return baseUrl ? `${baseUrl}${path}` : path;
};

export const resolveHistoryApiBaseUrl = (websocketUrl) => {
  if (process.env.REACT_APP_HISTORY_API_URL) {
    return process.env.REACT_APP_HISTORY_API_URL.replace(/\/$/, '');
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin.replace(/\/$/, '');
  }

  if (!websocketUrl) {
    return '';
  }

  try {
    const parsedUrl = new URL(websocketUrl);
    const protocol = parsedUrl.protocol === 'wss:' ? 'https:' : 'http:';
    return `${protocol}//${parsedUrl.host}`;
  } catch (error) {
    console.error('Failed to resolve history API base URL', error);
    return '';
  }
};
